export const ANIMATION_TIMINGS = '300ms ease-in';
export const TUTORIAL_CARDS: TutorialCard[] = [
  {
    title: 'Enter the room in a bubble',
    src: 'assets/images/tutorial/card-1.svg',
  },
  {
    title: 'Move around using the arrow keys on your keyboard, or by using your mouse to click around',
    src: 'assets/images/tutorial/card-2.svg',
  },
  {
    title: 'Move closer to people to hear them-- just like in real life',
    src: 'assets/images/tutorial/card-3.svg',
  },
];

export const EXPERIENCE_CARDS: TutorialCard[] = [
  {
    title: 'Gather with others around the room!  Group size is set by the host and can vary from 2-20 people.',
    src: 'assets/images/tutorial/experience-1.svg',
  },
  {
    title: 'Click the map icon in the bottom right to navigate around the room.',
    src: 'assets/images/tutorial/experience-2.svg',
    options: {
      customHTML: `
      <span class="map-arrow">
        <img src="assets/images/tutorial/arrow.SVG" alt="arrow" class="arrow"/>
        <img src="assets/images/tutorial/map-icon.SVG" alt="Map Icon" class="map-icon"/>
      </span>
      `,
    },
  },
];

export const MOBILE_MOVEMENT_CARD: TutorialCard = {
  title: 'Move around by tapping and holding in the direction that you would like your bubble to move',
  src: 'assets/images/tutorial/mobile-card-2.svg',
};

export interface TutorialCard {
  title: string;
  src: string;
  options?: {
    customHTML: string;
  };
}

export enum TutorialType {
  TUTORIAL,
  EXPERIENCE,
}
